// extracted by mini-css-extract-plugin
export default {"hello":"BxdDxWAQ"};